import { Fan } from "@/services/bedrock";

/**
 * Utility to extract default form values from a Fan record for use in FanCreationForm.
 */
export function getFanFormDefaultValues(
  fan: Partial<Fan> | null | undefined,
  playerId?: number,
  fallbackName?: string
) {
  if (!fan) {
    return {
      displayName: fallbackName || "",
      email: "",
      phoneNumber: "",
      fanType: "customer" as const,
      notes: "",
      playerId: playerId ?? null,
      stateCode: "",
      defaultLanguage: "en",
      internalIdentifier: "",
    };
  }

  return {
    displayName: fan.displayName || fallbackName || "",
    email: fan.email || "",
    phoneNumber: fan.phoneNumber || "",
    fanType: fan.fanType || "",
    notes: fan.notes || "",
    playerId: fan.player?.id || null,
    stateCode: fan.stateCode || "",
    defaultLanguage: fan.defaultLanguage || "",
    internalIdentifier: fan.internalIdentifier || "",
  };
}
